import { Guid } from "static/js/app/models/__index";

export class CallGroupOptions {
    constructor(
        public opGrp: string = Guid.create().toString(),
        public cancelOpGrpCalls: boolean = false
    ) { }
}
